import { render, staticRenderFns } from "./ChatWidget.vue?vue&type=template&id=448d488d&scoped=true&"
import script from "./ChatWidget.vue?vue&type=script&lang=js&"
export * from "./ChatWidget.vue?vue&type=script&lang=js&"
import style0 from "./ChatWidget.vue?vue&type=style&index=0&id=448d488d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448d488d",
  null
  
)

export default component.exports